import React from 'react'
import { Stack } from '@mui/material'

import { Icon, Typography } from '~components/internal'
import { borderRadius, colors, lightTokens, spacing } from '~tokens/internal'

export const ResponseFeedbackCard: React.FC<{
  impression: boolean
  submitter?: string
  feedback?: string
  created: Date
}> = ({ impression, submitter, feedback, created }) => {
  return (
    <Stack spacing={spacing.micro}>
      <Typography variant='caption' align='center'>
        {created.toLocaleString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
        })}{' '}
        at{' '}
        {created.toLocaleString('en-US', {
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',
          hour12: true,
        })}
      </Typography>
      <Stack
        spacing={spacing.xxs}
        sx={{
          backgroundColor: `${lightTokens.background.background3}4D`,
          border: `1px solid ${colors.neutral[300]}66`,
          borderRadius: borderRadius.md,
          px: spacing.sm,
          py: spacing.compact,
        }}
      >
        <Stack direction='row' spacing={spacing.xxs}>
          <Icon
            name={impression ? 'thumbUp' : 'thumbDown'}
            color={impression ? lightTokens.success.main : lightTokens.error.main}
            fill={0}
          />
          <Typography variant='body2'>
            {submitter ? submitter : impression ? 'Positive Impression' : 'Negative Impression'}
          </Typography>
        </Stack>
        {feedback && (
          <Stack spacing={spacing.micro}>
            <Typography variant='overline'>What the AI should have said</Typography>
            <Typography>{feedback}</Typography>
          </Stack>
        )}
      </Stack>
    </Stack>
  )
}
